exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-to-colours-page .details[data-v-02a2962e]{margin-bottom:0}", ""]);

// exports
